import z from 'zod';

export const addEventSchema = z.object({
  types: z.array(z.string()).min(1, 'At least one type is required'),
  name: z.string().min(1, 'Name is required'),
  startDate: z.string().refine((val) => !isNaN(Date.parse(val)), {
    message: 'Start date is required',
  }),
});
